export default {
  'clocks': []
}
